// Realistic, variable-length dummy names for the test-lease launcher (§5).
//
// The test tool prepopulates tenant names so the tester only has to set the
// property/unit and signer emails. Names are intentionally varied in length
// (short "Mia Ng" → long "Anastasia Worthington") so test leases exercise
// name-wrapping in the rendered document and signature blocks. These are
// fictional and not tied to any real applicant.

const FIRST_NAMES = [
  'Mia', 'Jordan', 'Alexander', 'Sofia', 'Liam', 'Anastasia', 'Wei',
  'Gabriella', 'Noah', 'Priya', 'Devon', 'Maximilian', 'Zoe', 'Ravi',
  'Ana', 'Christopher', 'Lena', 'Thaddeus', 'Yuki', 'Marcus',
];

const LAST_NAMES = [
  'Ng', 'Kim', 'Featherstone', 'Vandenberg', 'Cho', 'Okafor', 'Castillo',
  'Abernathy', 'Reyes', 'Worthington', 'Tan', 'Underwood', 'Sokolov',
  'Mbeki', 'Delacroix', 'Park', 'Hollingsworth', 'Diaz', 'Brandt', 'Osei',
];

function pick<T>(arr: readonly T[]): T {
  // Arrays above are non-empty constants, so the index is always in range.
  return arr[Math.floor(Math.random() * arr.length)] as T;
}

/** A fictional, variable-length "First Last" name for a test signer. */
export function randomRealisticName(): string {
  return `${pick(FIRST_NAMES)} ${pick(LAST_NAMES)}`;
}
